import { render } from "./IndexBreadcrumb.vue?vue&type=template&id=32869fc5&scoped=true&ts=true"
import script from "./IndexBreadcrumb.vue?vue&type=script&lang=ts"
export * from "./IndexBreadcrumb.vue?vue&type=script&lang=ts"

import "./IndexBreadcrumb.vue?vue&type=style&index=0&id=32869fc5&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32869fc5"]])

export default __exports__